import { Availability, MenuItem } from '@core/models';
import { CartItemAvailabilityStatusEnum } from '@core/enums';
import { JuvoTrackSession } from '@core/domain/local-channel';
import { isProductAvailable } from '@core/domain/availability';
import { calculateCartItemQuantity } from './cart-item-quantity.util';
import { hasStockChannel } from './cart-stock-channel.util';

export interface CartItemAvailabilityInput {
	item: MenuItem;
	cartItems: MenuItem[];
	availabilityList: Availability[] | null;
	localChannelSession: JuvoTrackSession | null;
	now?: Date;
}

export function getCartItemAvailabilityStatus({
	item,
	cartItems,
	availabilityList,
	localChannelSession,
	now = new Date(),
}: CartItemAvailabilityInput): CartItemAvailabilityStatusEnum {
	if (item.isUnavailable || !isProductAvailable(item.idArticulo, availabilityList, now)) {
		return CartItemAvailabilityStatusEnum.Unavailable;
	}
	if (!hasStockChannel(localChannelSession) || item.stock === null || item.stock === undefined) {
		return CartItemAvailabilityStatusEnum.Available;
	}

	return item.stock < calculateCartItemQuantity(cartItems, item.idArticulo)
		? CartItemAvailabilityStatusEnum.OutOfStock
		: CartItemAvailabilityStatusEnum.Available;
}
